/**
 * Unions API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ViewLoyaltyProduct } from './viewLoyaltyProduct';


/**
 * Список объявлений из поиска с пагинацией.
 */
export interface LoyaltyProductsWithCount { 
    /**
     * Найденая часть объявлений в соответсвии с запросом фронта с пагинацией.
     */
    items?: Array<ViewLoyaltyProduct>;
    /**
     * Кол-во объявлений, которые уже найдены (с 1го) при зпросах с пагинацией включая эти.
     */
    passedCount?: number;
}

